import { render, staticRenderFns } from "./CurrencyEdit.vue?vue&type=template&id=fdcd0520&"
import script from "./CurrencyEdit.vue?vue&type=script&lang=js&"
export * from "./CurrencyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports